export const locale = {
  lang: 'fr-CA',
  data: {
    TOOLBAR: {
      HISTORY: 'Historique',
      HISTORIES: 'Historiques',
      NO_HISTORY: 'Aucun historique',
      FULLSCREEN: 'Plein écran',
      MY_PROFILE: 'Mon Profil',
      DARKMODE: 'Mode Foncé',
      LIGTHMODE: 'Mode Clair',
      ORGANIZATION: 'Organisation',
      LOGOUT: 'Déconnexion',
      RESET_TABLE: 'Réinitialisé',
      SUGGEST_HINT:
        'Flèches haut/bas pour choisir, Entrée pour ouvrir la fiche, Entrée sans choix = tous les résultats',
      CREATE_EMPLOYEE: 'Créer un employé',
      CREATE_PRODUCT: 'Créer un produit',
      CREATE_PRODUCT_COMBO: 'Créer un combo',
      CREATE_PRODUCT_COMBO_DYNAMIC: 'Créer un combo dynamique',
      CREATE_ORDER: 'Créer une commande',
      CREATE_PLACE: 'Créer un lieu',
      CREATE_ENTERPRISE: 'Créer une entreprise',
      CREATE_CLIENT: 'Créer un client',
      CREATE_CLIENT_ENTERPRISE: 'Créer un client et entreprise',
      CREATE_MATERIAL: 'Créer un matériel',
      CREATE_MATERIAL_COMBO: 'Créer un ensemble',
      SETTINGS: 'Configuration',
      CREATE_PROPOSAL: 'Nouvelle proposition',
      CATERER: 'Traiteur',
      SHOP: 'Boutique',
      CREATE_CONGRES: 'Créer un congrès',
      OPEN_NEW_TAB: 'Ouvrir dans un nouvel onglet',
      QUICK_ORDER: 'Commande rapide',
      NEW_PICKUP: 'Nouvelle Cueillette [Beta]',
      NOTIFICATIONS: 'Notifications',
      NOTIFICATIONS_NONE: 'Notifications, aucune non lue',
      NOTIFICATIONS_ONE: 'Notifications, 1 non lue',
      NOTIFICATIONS_MANY: 'Notifications, {{count}} non lues',
      PREFERENCES: 'Préférences',
    },
  },
};
